import SimpleTablePage from "../common/SimpleTablePage";
import { Link } from "react-router";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 50,
    render: (id) => <Link to={`${id}`}>{id}</Link>,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "description",
    ellipsis: true,
  },
];

export default function () {
  return <SimpleTablePage resource="workSite" columns={columns} />;
}
